import { Icon } from "components";
import { useIsOffline } from "hooks";
import Offline from "pages/Offline";
import { Toaster } from "react-hot-toast";
import { useRoutes } from "react-router";
import { Fragment } from "react/jsx-runtime";
import routes from "./routes";

export default function App() {
  const isOffline = useIsOffline();
  const elements = useRoutes(routes);
  if (isOffline) return <Offline />;
  return (
    <Fragment>
      {elements}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          className:
            "bg-[#3D3F4E] text-white text-sm font-normal min-w-[350px] min-h-[60px] [&>div]:text-start [&>div]:justify-start",
          icon: <Icon name="InfoCircle" className="size-6" />,
        }}
      />
    </Fragment>
  );
}
